<template>
  <div
    v-if="block.two_text_columns?.length"
    ref="blockRef"
    class="grid gap-6 mx-auto px-4 max-w-6xl sm:grid-cols-2 sm:gap-6 sm:px-6 lg:gap-24"
  >
    <div v-for="column in block.two_text_columns" :key="column.id">
      <div
        v-if="column.title"
        class="font-serif font-bold text-[clamp(1.5rem,0.0455rem+7.2727vw,2.5rem)] text-purple-dark leading-none"
        data-gsap-target="title"
      >
        {{ column.title }}
      </div>

      <div
        v-if="column.text"
        v-html="column.text"
        class="prose mt-4 md:mt-8"
        data-gsap-target="text"
      />

      <Buttons
        v-if="column.buttons?.length"
        :buttons="column.buttons"
        class="mt-auto pt-8 xl:pt-12"
        data-gsap-target="buttons"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TwoTextColumns } from '~/statamic/types/block';

defineProps<{
  block: TwoTextColumns;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    const titles = self.selector('[data-gsap-target="title"]');
    const texts = self.selector('[data-gsap-target="text"]');
    const buttons = self.selector('[data-gsap-target="buttons"]');

    if (titles?.length) {
      useGsap.from(titles, {
        x: -100,
        stagger: 0.25,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }

    if (texts?.length) {
      useGsap.from(texts, {
        y: 100,
        delay: 0.25,
        stagger: 0.25,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }

    if (buttons?.length) {
      useGsap.from(buttons, {
        y: 50,
        delay: 0.25,
        stagger: 0.25,
        autoAlpha: 0,
        scrollTrigger: {
          start: 'top bottom',
          trigger: blockRef.value,
        },
      });
    }
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
